import * as XLSX from "xlsx";
import { message } from "antd";

export interface ExcelColumn<T = any> {
  header: string;
  key?: keyof T | string;
  formatter?: (row: T, index: number) => any;
  width?: number;
}

export const exportToExcel = <T = any>(
  data: T[],
  columns: ExcelColumn<T>[],
  fileNamePrefix: string
) => {
  if (!data || data.length === 0) {
    message.warning("No data available to export!");
    return;
  }

  try {
    const formattedData = data.map((item, index) => {
      const row: Record<string, any> = {};
      columns.forEach((col) => {
        if (col.formatter) {
          const val = col.formatter(item, index);
          row[col.header] = val !== undefined && val !== null ? val : "";
        } else if (col.key) {
          const val = (item as any)[col.key];
          row[col.header] = val !== undefined && val !== null ? val : "";
        } else {
          row[col.header] = "";
        }
      });
      return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedData);

    const colWidths = columns.map((col) => {
      if (col.width) return { wch: col.width };
      const maxContentLength = Math.max(
        col.header.length,
        ...formattedData.map((row) => String(row[col.header] ?? "").length)
      );
      return { wch: Math.min(Math.max(maxContentLength + 3, 12), 50) };
    });

    worksheet["!cols"] = colWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const dateStr = new Date().toISOString().slice(0, 10);
    const fileName = `${fileNamePrefix}_${dateStr}.xlsx`;

    XLSX.writeFile(workbook, fileName);
    message.success(`${fileName} downloaded successfully!`);
  } catch (error) {
    //console.error("Export to Excel failed:", error);
    message.error("Failed to export Excel sheet.");
  }
};
